import { Component, HostBinding, OnInit } from '@angular/core';
import { MenuStore } from '../service/menu.store';
import { Router } from '@angular/router';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';
import { CompletedUnpaidDashboardStore } from '../../event/service/completed-unpaid-dashboard.store';
import { Observable } from 'rxjs/Observable';
import { DashboardUtils } from '../../event/utils/dashboard-util';
import { MissingAgencyDashboardStore } from '../../event/service/missing-agency-dashboard.store';
import { PredefinedSearchService } from '../../event/service/predefined-search.service';

@Component({
  selector: 'pioneer-app-menu',
  templateUrl: './app-menu.component.html'
})
export class AppMenuComponent implements OnInit {

  @HostBinding('class.left-nav') true;
  @HostBinding('class.nav-collapsed')
  isNavCollapsed;

  constructor(
    private menuStore: MenuStore,
    private router: Router,
    private eventSearchParametersStore: EventSearchParametersStore,
    private completedUnpaidStore: CompletedUnpaidDashboardStore,
    private missingAgencyStore: MissingAgencyDashboardStore,
    private predefinedSearchService: PredefinedSearchService
  ) {}

  ngOnInit(): void {
    this.isNavCollapsed = this.menuStore.isNavCollapsed;
  }

  toggleNavCollapsed(): void {
    this.isNavCollapsed = this.menuStore.toggleIsNavCollapsed();
  }

  /**
   * Matches the '/events' route
   * Matches the '/events?...' route
   * Does NOT match the '/events/add' route
   * @return {boolean}
   */
  isOnSearchEvents(): boolean {
    return this.isUrlOnPath('/events') || this.isUrlOnPath('/events/financial');
  }

  isOnDashboard(): boolean {
    return this.isUrlOnPath('/dashboard');
  }

  isUrlOnPath(path: string) {
    let url = this.router.url;
    let indexOfQuestionMark = url.indexOf('?');

    // if there is a question mark in the url,
    //   then get the url up to the question mark
    if (indexOfQuestionMark >= 0) {
      url = url.substr(0, indexOfQuestionMark);
    }

    // check to see if on the events route
    return !!(url && url === (path));
  }

  navigateToSearch(): void {
    this.eventSearchParametersStore.updateUrl();
  }

  get completedAndUnpaidTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.completedAndUnpaidTotal);
  }

  get missingAgencyTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
  }

  showCompletedAndUnpaidTotals(): Observable<boolean> {
    return Observable.combineLatest(
      this.completedUnpaidStore.isLoading(),
      this.completedUnpaidStore.isStale()
    ).map(values => {
      const [loading, stale] = values;
      return !Boolean(loading || stale);
    });
  }

  showMissingAgencyTotals(): Observable<boolean> {
    return Observable.combineLatest(
      this.missingAgencyStore.isLoading(),
      this.missingAgencyStore.isStale()
    ).map(values => {
      const [loading, stale] = values;
      return !Boolean(loading || stale);
    });
  }

  missingAgencyPredefinedSearch() {
    this.predefinedSearchService.missingAgencySearch();
  }

  completedAndUnpaidPredefinedSearch() {
    this.predefinedSearchService.completedAndUnpaid();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/app-menu/app-menu.component.ts